import { IngestionClient } from '@phonepe/conduit';
import { BUILD_ENVIRONMENT } from './app.types';

export interface IBaseEvent {
	eventType: TAnalyticsEventType;
}
export interface IAnalyticsEventDetails {
	name: string;
	value?: string | number | boolean;
	additionalData?: Record<string, unknown>;
}

export interface IGarfieldEvent extends IBaseEvent {
	eventName: IAnalyticsEventDetails['name'];
	value: IAnalyticsEventDetails['value'];
	additionalData: IAnalyticsEventDetails['additionalData'];
}

export interface IGarfieldEventWithData extends IGarfieldEvent {
	data?: object;
}

type IngestionClientOptions = ConstructorParameters<typeof IngestionClient>[0];

// NOTE: Ask conduit to expose type from conduit
export type FoxtrotClient = NonNullable<
	ReturnType<InstanceType<typeof IngestionClient>['getClients']>['foxtrot']
>;

export interface IFoxtrotConfig {
	app: string;
	customIngestionHandler?: IngestionClientOptions['customAxiosFn'];
	flushInterval?: number;
}

export interface IGarfieldConfig {
	trackerId: TTrackerId;
	authFlow?: {
		fingerprint: string;
		version: string;
		isLoggedIn?: boolean;
	};
	handleGarfieldEventData?: (
		eventSchema: IGarfieldEvent,
	) => IGarfieldEventWithData;
}
export interface IAnalyticsBaseConfig {
	environment?: BUILD_ENVIRONMENT;
}

export interface IAnalyticsConfig extends IAnalyticsBaseConfig {
	foxtrot?: IFoxtrotConfig;
	garfield?: IGarfieldConfig;
}

export interface IEventConfig {
	isGarfieldEnabled?: boolean;
	isFoxtrotEnabled?: boolean;
	/**
	 * @description This is used to push events to a temporary queue till the time auth is not present. Default value : false
	 */
	pushToQueue?: boolean;
}

export type TAnalyticsEventType =
	| 'custom'
	| 'click'
	| 'pageview'
	| 'apiError'
	| 'networkMetric';

export type TAnalyticsEventSchema = {
	eventData: IAnalyticsEventDetails;
	/**
	 * @description This is used to push events to a temporary queue till the time auth is not present.
	 * Default value : false
	 */
	pushToQueue?: boolean;
} & IBaseEvent;

export enum AnalyticsClientName {
	FOXTROT = 'Foxtrot',
	GARFIELD = 'Garfield',
}

export type TTrackerId =
	| 'PHONEPE_MERCHANT_OFFLINE'
	| 'PHONEPE_MERCHANT_ONLINE'
	| 'PHONEPE_FASTAG_PASS';

export interface IEventData {
	type: TAnalyticsEventType;
	data: IAnalyticsEventDetails;
}

export type TSendAnalyticsEventFunction = (payload: IEventData) => void;
export type TFlushQueuedEventHandler = (
	data: TAnalyticsEventSchema,
) => TAnalyticsEventSchema;
